import { defineComponent as _defineComponent } from 'vue'
import ServicoService from '@/services/ServicoService';
import Irmao from '@/../common/types/Irmao'
import { useQuery } from '@tanstack/vue-query';
import { adminIrmaoGuard } from '@/shareds/sharedsIrmao';
import ComponentAuthGuard from '@/components/ComponentAuthGuard.vue';
import DialogExcluirServico from '@/components/servico/DialogExcluirServico.vue';
import DialogDetalhesDoServico from '@/components/servico/DialogDetalhesDoServico.vue';
import { ref } from 'vue';
import { Servico } from 'common/types/Servico';


export default /*#__PURE__*/_defineComponent({
  __name: 'AbaDeServicosDoIrmao',
  props: {
    irmao: null
  },
  setup(__props: any) {

const prop = __props as { irmao: Irmao };



const mostraServico = ref(false)
const selecionado = ref<Servico>()

function mostrarServico(servico: Servico) {
	selecionado.value = servico
	mostraServico.value = true
}

const { data: paginas, error, isLoading } = useQuery({
    queryKey: ['servicos', prop.irmao._id],
    queryFn: () => ServicoService.findPage({
        irmao: prop.irmao._id,
    }),
})

return { __sfc: true,prop, mostraServico, selecionado, mostrarServico, paginas, error, isLoading, adminIrmaoGuard, ComponentAuthGuard, DialogExcluirServico, DialogDetalhesDoServico }
}

})